import { differenceInMonths, addMonths, addYears, differenceInYears } from 'date-fns';
import { BaseWorkspace } from '@/types/auth.types';
import { BillingCycle, SubscriptionType } from '@/types/shared';

type Subscription = BaseWorkspace['subscription'];

export const getMonthlyAllocatedCredits = (subscription?: Subscription): number | null => {
  return subscription?.type !== SubscriptionType.Enterprise ? (subscription?.monthlyCredits ?? null) : null;
};

export const canCreditsRollover = (subscription?: Subscription): boolean => {
  if (!subscription) return false;
  return ![SubscriptionType.Free, SubscriptionType.Starter].includes(subscription.type);
};

export const getRenewalDate = (subscription?: Subscription): Date | null => {
  if (!subscription?.startsAt || subscription.type === SubscriptionType.Free) return null;

  const today = new Date();
  const startDate = new Date(subscription.startsAt);

  if (subscription.billingCycle === BillingCycle.Yearly) {
    const yearsSinceStart = differenceInYears(today, startDate);
    return addYears(startDate, yearsSinceStart + 1);
  }

  // Monthly billing cycle
  const monthsSinceStart = differenceInMonths(today, startDate);
  return addMonths(startDate, monthsSinceStart + 1);
};
